import React from 'react';
import { Link } from "react-router-dom";
import routes from 'src/routes';
import Page from 'src/components/Page';

function WebhookPage() {

    return <Page header="Webhooks">
        <p>
            Webhooks are an asynchronous notification mechanism.
            They notify merchant systems that a successful operation has taken place and provide a detailed result.
        </p>
        <p>
            Webhooks are triggered only if the merchant has provided a Webhook URL for a request.
            The BPoint system will send the Webhook notification upon transaction completion.  Should the notification fail delivery, BPoint will re-attempt at one hour intervals for the next 24 hours until successfully delivered.
        </p>
        
        <h2>APIs that support Webhooks</h2>
        <p>
            There are four APIs that support Webhooks:
        </p>

        <h3>Transaction based Webhooks</h3>
        <p>
            There are three transaction endpoints that support Webhooks.            
        </p>
        <table className="field-table">
            <thead>
                <tr>
                    <th>Endpoint</th>
                    <th>More information</th>                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><Link to={routes.api.spec + "#operation/Txn_Process"}>2-party Process transaction</Link></td>
                    <td><Link end to={routes.api.twoparty.root}>2-party</Link></td>
                </tr>
                <tr>
                    <td><Link to={routes.api.spec + "#operation/TxnAuthkey_AttachHppConfigurationWithWebhook"}>Attach HPP configurations</Link></td>
                    <td><Link end to={routes.api.txn.authkey.hpp}>HPP Configuration</Link></td>
                </tr>
                <tr>
                    <td><Link to={routes.api.spec + "#operation/TxnAuthkey_Process"}>Process transaction with AuthKey</Link></td>
                    <td>
                        <p>You can invoke Webhooks for any AuthKey integration:
                            <ul><Link end to={routes.api.txn.authkey.javascriptSimple}>JavaScript - Simple</Link></ul>
                            <ul><Link end to={routes.api.txn.authkey.javascriptAdvanced}>JavaScript - Advanced</Link></ul>
                            <ul><Link end to={routes.api.txn.authkey.iframeFields}>Iframe Fields</Link></ul>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>

        <h3>Token based Webhooks</h3>
        <p>One token endpoint supports Webhooks:</p>
        <table className="field-table">
            <thead>
                <tr>
                    <th>Endpoint</th>
                    <th>More information</th>                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><Link to={routes.api.spec + "#operation/TokenAuthkey_Process"}>Process token with AuthKey</Link></td>
                    <td>
                        <p>You can invoke Webhooks for any AuthKey integration:
                            <ul><Link end to={routes.api.token.authkey.javascriptSimple}>JavaScript - Simple</Link></ul>
                            <ul><Link end to={routes.api.token.authkey.javascriptAdvanced}>JavaScript - Advanced</Link></ul>
                            <ul><Link end to={routes.api.token.authkey.iframeFields}>Iframe Fields</Link></ul>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>


        <h2>Webhook content</h2>
        <p>
            All Webhook calls are HTTP POST methods containing a JSON payload. The contents of the payload depend on the action that caused the Webhook call to be made.
        </p>
        <table className="field-table">
            <thead>
                <tr>
                    <th>Key</th>
                    <th>Type</th>
                    <th>Description</th>                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>type</td>
                    <td>string</td>
                    <td>Type of the data object</td>
                </tr>
                <tr>
                    <td>data</td>
                    <td>object</td>
                    <td>Webhook data payload, structure depends on type of webhook</td>
                </tr>
            </tbody>
        </table>

        <p>
            There is a possibility that multiple Webhook calls for the same action may be received by the Merchant's server.
            For this reason, it is important that Webhook request contents are checked for uniqueness (see Uniqueness column in table below) prior to updating data.              
        </p>
        <table className="field-table">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Data structure</th>
                    <th>Uniqueness</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><code>transaction</code></td>
                    <td>Same as response of <Link to={routes.api.spec + '#operation/Txn_GetTxn'}>Get Txn</Link></td>
                    <td><code>txnNumber</code> field</td>
                </tr>
                 <tr>
                    <td><code>token</code></td>
                    <td>Same as response of <Link to={routes.api.spec + '#operation/Token_GetToken'}>Get Token</Link></td>
                    <td><code>token</code> and <code>updatedDateTime</code> fields</td>
                </tr>
            </tbody>
        </table>

        <h2>Firewall Configuration</h2>
        <p>
            For connections initiated by our servers (Webhook callbacks), all connections are initiated from the following IP addresses:
        </p>
        <ul>
            <li>203.195.127.4 (Production)</li>
            <li>202.166.187.3 (Production)</li>
            <li>103.91.167.3 (UAT)</li>
        </ul>
        <p>
            For Webhook calls, only requests to HTTPS services on port 443 will be attempted.
        </p>

        <h2>China UnionPay</h2>
        <p>
            China UnionPay transactions will always have a response code of <code>P</code> (Pending).
            You will need to poll BPoint using the <Link to={routes.api.spec + "#operation/Txn_SearchTxns"}>Search Transaction</Link> endpoint to obtain the result.
            China UnionPay only returns a response for approved transactions. If the transaction is not completed and approved within 2 hours then a response code of <code>"x" - "description"</code> will be returned.
        </p>

    </Page>;
}

export default WebhookPage;